<template>
  <div class="item-selecao-menu">
    <div v-for="item in itensMenu_" :key="item.id" @click="selectItem(item)">
      <ItemSelecao
        :textoprincipal="item.textoprincipal"
        :textosecundario="item.textosecundario"
        v-if="visibilidade(item)"
      />
    </div>
    <div class="div-f-c" v-if="!inicio" @click="paginaanterior()">
      <span class="material-icons icon-button-minicard">keyboard_arrow_left</span> Voltar
    </div>
    <div v-else style="margin-bottom: 20px"></div>
  </div>
</template>

<script>
import ItemSelecao from "./ItemSelecao.vue";
import { mapGetters} from "vuex";

export default {
  name: "_Menu",
  components: {
    ItemSelecao,
  },
  data() {
    return {
      itemSelecionado: null,
    };
  },
  props: ["itensMenu", "inicio"],
  computed: {
    ...mapGetters({
      statusParticipacao: "statusParticipacao"    
    }),
    itensMenu_() {
      return this.itensMenu
    }
  },
  methods: {
    selectItem(item) {
      this.itemSelecionado = item;
      this.$emit("itemselecionado", item);
    },
    paginaanterior() {
      this.$emit("retornar", this.itemSelecionado);
    },
    visibilidade(item) {
      if (item && item.visivel && item.textoprincipal !== "Sair do App") {
        return item.visivel.includes(this.statusParticipacao);
      } else if (item && item.visivel && item.textoprincipal === "Sair do App") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.item-selecao-menu {
  margin: 0px 20px;
}
.material-icons {
  font-size: 30px;
  padding: 3px;
}
.icon-button-minicard {
  color: #317abb;
  background-color: #ff000000;
}
.div-f-c {
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
